import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import { fetchWorkshopEnrolment, WORKSHOP_ENROLMENT_FETCH_REQUEST, WORKSHOP_ENROLMENT_FETCH_SUCCESS, WORKSHOP_ENROLMENT_FETCH_FAILURE } from './actions';
import { cancelWorkshopSession } from '../actions';
import { getChild } from '../reducer';
import PaymentView from './View';
import BackButton from '../../common/components/BackButton';

class Details extends Component {
	componentDidMount() {
		this.props.fetchWorkshopEnrolment(Number(this.props.match.params.id));
		this.handleCancelSession = this.handleCancelSession.bind(this);
	}
	handleCancelSession(sessionId) {
		const { cancelWorkshopSession } = this.props;
		const onSuccess = () => {
			this.props.fetchWorkshopEnrolment(Number(this.props.match.params.id));
		}
		cancelWorkshopSession(sessionId, onSuccess);
	}
	render() {
		const { enrolment, enableUserTimeZone } = this.props;

		return <div>
			{enrolment && <PaymentView payment={enrolment} cancelSession={this.handleCancelSession} enableUserTimeZone={enableUserTimeZone}
				blockSessions={WORKSHOP_ENROLMENT_FETCH_REQUEST} unblockSessions={[WORKSHOP_ENROLMENT_FETCH_SUCCESS, WORKSHOP_ENROLMENT_FETCH_FAILURE]} />}
			<Row className='parent-dashboard-box'>
				<Col sm={12}>
					<BackButton />
				</Col>
			</Row>
		</div>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const enrolmentId = ownProps.match.params.id;
	const fromPath = ownProps.match.params.fromPath;

	const { parent, entities: { workshopEnrolments, centers }, configuration: { franchisor } } = state;

	const enrolment = workshopEnrolments[enrolmentId];
	if (enrolment) {
		enrolment.child = getChild(parent, enrolment.childId);
		enrolment.center = centers[enrolment.centerId];		
	}

	return {
		enrolment,
		fromPath,
		enableUserTimeZone: franchisor && franchisor.enableUserTimeZone
	};
};

export default connect(mapStateToProps, {
	fetchWorkshopEnrolment,
	cancelWorkshopSession
})(withNamespaces()(Details));